import { render, staticRenderFns } from "./PendenciasPage.vue?vue&type=template&id=59dffdd0&scoped=true"
import script from "./PendenciasPage.vue?vue&type=script&lang=js"
export * from "./PendenciasPage.vue?vue&type=script&lang=js"
import style0 from "./PendenciasPage.vue?vue&type=style&index=0&id=59dffdd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dffdd0",
  null
  
)

export default component.exports